export default __webpack_public_path__ + "static/media/Black-PDF.9db2fe06.svg";